module.exports = __webpack_public_path__ + "assets/media/accounts-page-preview.7882bb0d.png";